

jQuery(document).ready(function() {
  AOS.init();
const $ = jQuery;
const xxlarge= 1440;
const xlarge= 1200;
const large = 1023;
const medium = 799;
const small = 450;
var timeOut = null;
var scrollDownCountDown = null;


const setEventHeight = () => {
    $('.sections--sub-event__inner--pic').css( 'height', $('.sections--sub-event__inner--pic').width() )
    $('.inner-flex').css( 'height', $('.sections--sub-event__inner--pic').width() )
    $('.trackImages').css( 'height', $('.sections--sub-event__inner--pic').width() / 2 - 30)
}
  


const setAboutUsHeight = () => {

  $('.square-auto--responsive').css( 'height', $('.square-auto--responsive').width())
  $('.sections--about-us-2 .carousel-nav').css('top', $('.square-auto--responsive').width() + 20 )
  $('.square-auto ').css( 'height', $('.square-auto').width())

 
//  let squareText = $('.square-auto--text').height();
//  let squareHeight=  $('.square-auto').height();
  
//  if (squareText > $('.square-auto').height()) {
//   let needZoom = squareHeight / squareText;
//   $('.square-auto--text').css(`transform`, `scale(${needZoom})`)
  
//   }
}




$('.all-events-carosel--container').slick({
    arrows: false,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
        {
            breakpoint: xxlarge,
            settings: {
              slidesToShow: 3,
            }
          },
        {
          breakpoint: large,
          settings: {
            slidesToShow: 2,
            centerMode: true,
          }
        },
        {
          breakpoint: medium,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });

  $('.all-events-carosel--container').on('wheel', (function(e) {
    e.preventDefault();
  
    if (e.originalEvent.deltaY < 0) {
      $(this).slick('slickNext');
    } else {
      $(this).slick('slickPrev');
    }
  }));


$('.cars-carosel--container').slick({  adaptiveHeight: true });






let responsiveCarosel = (slides) => {
if ($('.responsive-carosel--container') && !$('.responsive-carosel--container').hasClass('slick-initialized')) {

    $.each($('.responsive-carosel--container'), function(index, element) {
    let countInnerSlider = $(element).children('.inner-res-slider').length;
    if (
     countInnerSlider > 1 &&
    (countInnerSlider > 2 || countInnerSlider <= 2 && $( window ).width() < medium )) {
    $(element).slick({
        arrows: false,
        responsive: [
            {
              breakpoint: large,
              settings: {
                slidesToShow: 2,
                // centerMode: true,
              }
            },
            {
              breakpoint: medium,
              settings: {
                slidesToShow: 1
              }
            }
          ]
      });
    }
})
    }
    $('.carousel-prev').click(function(){ 
		$(this).parent().find('.slick-slider').slick('slickPrev');
	} );
	
	$('.carousel-next').click(function(e){
		e.preventDefault(); 
		$(this).parent().find('.slick-slider').slick('slickNext');
	} );
}

let setAbsoluteClassOnSideBars = () => {
  if ($( window ).height() < 770) {
      $('.left-site-bar--outer').addClass('sidebar-outer-absoulute');
      $('.right-site-bar--outer').addClass('sidebar-outer-absoulute');
   } else {
       if ($('.left-site-bar--outer').hasClass('sidebar-outer-absoulute') ||
       $('.right-site-bar--outer').hasClass('sidebar-outer-absoulute')) {
       $('.left-site-bar--outer').removeClass('sidebar-outer-absoulute');
       $('.right-site-bar--outer').removeClass('sidebar-outer-absoulute'); 
       }
   }
}


function truncateText(lettersWidth, lines) {

  let oneLetterWidth = lettersWidth;
  let howManyLines = lines;
  let dots = '...';
  let calcLetters = (textHtmlWidth) => {
    return Math.round(textHtmlWidth / oneLetterWidth * howManyLines);
  }
$.each($('.dots-title-js'), function(index, el) {
  let textHtmlWidth = $(el).width();
  let $visible = $(el).children('.visible-el');
  let $hidden = $(el).children('.hidden-el');
  let hiddenText = $hidden.text().replace(/[\n\r]+/g, ' ').trim();
  if (hiddenText.length > calcLetters(textHtmlWidth)) $visible.html((hiddenText.slice(0, calcLetters(textHtmlWidth) - 3) + dots).trim());
})
}

let screens = () => {
    setEventHeight();
    let dataProp = $('.close-side-bar').length > 0 && Object.keys($('.close-side-bar').data())[0];
    if ($( window ).width() < large && $( window ).width() >= medium ) {
        $('.site-content').removeClass('medium-display');
        $('.site-content').removeClass('small-display');
        $('.site-content').addClass('large-display');
        if ( $('.close-side-bar').length > 0 && !$('.close-side-bar').data()[dataProp] && !timeOut) {
      
            timeOut = setTimeout(() => { $('.close-side-bar').click(); clearTimeout(timeOut); timeOut = null; }, 4000);
        }
        // responsive carosel for the EventSource, racers and etc.

        responsiveCarosel();

    }
    else if ($( window ).width() < medium && $( window ).width() >= small) {
        $('.site-content').removeClass('medium-display');
        $('.site-content').removeClass('small-display');
        $('.site-content').addClass('medium-display');

        if ( $('.close-side-bar').length > 0 && !$('.close-side-bar').data()[dataProp] && !timeOut) {
            timeOut = setTimeout(() => { $('.close-side-bar').click(); clearTimeout(timeOut); timeOut = null; }, 4000);
        }
        responsiveCarosel();
    }
    else if ($( window ).width() < small && $( window ).width() < medium ) {
        $('.site-content').removeClass('large-display');
        $('.site-content').removeClass('medium-display');
        $('.site-content').addClass('small-display');
        responsiveCarosel();
    }
    else {
        $('.site-content').removeClass('large-display');
        $('.site-content').removeClass('medium-display');
        $('.site-content').removeClass('small-display');

        if ( $('.close-side-bar').length > 0 && $('.close-side-bar').data()[dataProp]) {
            $('.close-side-bar').click();
        }
        if ('.responsive-carosel--container' && $('.responsive-carosel--container').hasClass('slick-initialized')) {
            $('.responsive-carosel--container').slick('unslick');
        }
    }
    let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        setAboutUsHeight();
        truncateText(16, 3);
}
screens();
setAbsoluteClassOnSideBars();

scrollDownCountDown = setTimeout(() => { 
$('.scroll-down').addClass('scroll-down--show'); 
$('.carousel-nav__inner').addClass('carousel-nav__inner--events--show'); 

clearTimeout(scrollDownCountDown); scrollDownCountDown = null; }, 
2800);

// responsive function
$(window).resize(function() {
  screens();
  setAbsoluteClassOnSideBars();
});

$( ".scroll-down__inner--events .right" ).on('click', function() {
  $('.all-events-carosel--container').slick('slickNext');
})

$( ".scroll-down__inner--events .left" ).on('click', function() {
  $('.all-events-carosel--container').slick('slickPrev');
})



// let scrollTo = 50;
// $( ".scroll-down__inner--mouse" ).draggable({ axis: "y", drag: function( event, ui ) {
//   $(".single-racer__text").getNiceScroll(0).doScrollTop(scrollTo, 500)
//   if (ui.originalPosition.top <  ui.position.top) {
//     scrollTo = scrollTo + 10;
//   } else {
//     scrollTo = scrollTo - 10;
//   }
// } });

$('.send-inquiry').on('click', function() {
  let carNumber = $(this).data().carNumber;
  $('.selecType').val(carNumber).prop('selected', true);
})


// $('.about-us-list')


// make the conteiner with slick slider in smal res
console.log('ready')
}); 